// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {
    private sidebarSubject = new BehaviorSubject<boolean>(true);
    private title = new BehaviorSubject<string>('');
    private navigateTo = new BehaviorSubject<string>('');

    show$ = this.sidebarSubject.asObservable();
    title$ = this.title.asObservable();
    navigateTo$ = this.navigateTo.asObservable();

    show() {
        this.sidebarSubject.next(true);
    }

    hide() {
        this.sidebarSubject.next(false);
    }

    setTitle(title: string, navigateTo?: string) {
        this.title.next(title);
        if (navigateTo) {
            this.navigateTo.next(navigateTo);
        }
        else {
            this.navigateTo.next('/');
        }
    }

    clearTitle() {
        this.title.next('');
        this.navigateTo.next('/');
    }
}